var storage = "https://api-dev-elikia-funding.fewnu.app";
// var api = "http://127.0.0.1:8000/api/";
// var storage = "https://api-recette-elikia-funding.fewnu.app";
// var storage = "https://api-easy-funding.fewnu.app";

export default storage;